import * as React from 'react'

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  trimOnBlur?: boolean
  onChange: (value: string) => void
}

export default function InputTextComponent ({ trimOnBlur = true, onBlur, onChange, value, ...rest }: Props) {
  const handleBlur = React.useCallback((evt: React.FocusEvent<HTMLInputElement>) => {
    if (trimOnBlur && typeof value === 'string' && onChange) {
      const trimmed = value.trimEnd()
      if (trimmed && value && trimmed !== value) onChange(trimmed)
    }
    onBlur?.(evt)
  }, [trimOnBlur, onChange, onBlur, value])

  const effectiveOnBlur = trimOnBlur || onBlur ? handleBlur : undefined

  return <input type="text" value={ value ?? '' } onChange={ evt => onChange(evt.target.value) } onBlur={ effectiveOnBlur } { ...rest } />
}